module.exports = __webpack_public_path__ + "img/Harbind Thapar, Co-Director of SIF, Schu.a6d170c7.webp";